<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<BlockReportTable></BlockReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import BlockReportTable from '@/components/Report/BlockReportTable.vue';

export default {
	name: 'BlockReport',
	components: {
		BlockReportTable
	}
};
</script>
